import {
    BooleanField,
    FunctionField,
    ReferenceField,
    SimpleShowLayout,
    TextField,
} from 'react-admin';
import { formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";

function AreaMetaShow() {    
    return (
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <ReferenceField source="cityId" link="show" reference="Cities">
                <TextField source="name" />
            </ReferenceField>
            <BooleanField source="isServiceable" />
            <BooleanField source='isInstantChefitAvailable' />
            <BooleanField source='hasPayAfterService' />
            <FunctionField label="Book By Dish Multiplier" render={(record: any) => record?.bookByDishMultiplier ?? '-'} />
            <FunctionField label="Created At" render={(record: any) => record?.createdAt ? formatDateTimeWithSeconds(record.createdAt) : '-'} />
            <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? formatDateTimeWithSeconds(record.updatedAt) : '-'} />
        </SimpleShowLayout>
    )
}

export default AreaMetaShow;
